/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Bot_UpdatedInputs */

const tr_landing_pricerules_mock_bot_updated = /** @type {(inputs: Landing_Pricerules_Mock_Bot_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`27 ürün güncellendi.`)
};

const en_landing_pricerules_mock_bot_updated = /** @type {(inputs: Landing_Pricerules_Mock_Bot_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`27 products updated.`)
};

const de_landing_pricerules_mock_bot_updated = /** @type {(inputs: Landing_Pricerules_Mock_Bot_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`27 Produkte aktualisiert.`)
};

const ru_landing_pricerules_mock_bot_updated = /** @type {(inputs: Landing_Pricerules_Mock_Bot_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновлено 27 товаров.`)
};

/**
* | output |
* | --- |
* | "27 products updated." |
*
* @param {Landing_Pricerules_Mock_Bot_UpdatedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_bot_updated = /** @type {((inputs?: Landing_Pricerules_Mock_Bot_UpdatedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Bot_UpdatedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_bot_updated(inputs)
	if (locale === "de") return de_landing_pricerules_mock_bot_updated(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_bot_updated(inputs)
	return tr_landing_pricerules_mock_bot_updated(inputs)
});